import { Box } from '@mui/material';
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { AverageTestScoreBySubject } from '../types';

export const ColumnBarChart = ({ averageTestScoreBySubject }: {
  averageTestScoreBySubject: AverageTestScoreBySubject,
}) => {
  const categories: { [subject: string]: boolean } = {};
  const seriesVina: number[] = [];
  const seriesSantiago: number[] = [];
  const seriesNoSede: number[] = [];
  const seriesOnline: number[] = [];
  const seriesGeneral: number[] = [];
  if (Object.keys(averageTestScoreBySubject).length) {
    Object.keys(averageTestScoreBySubject).forEach((key) => {
      const data = averageTestScoreBySubject[key];
      if (data) {
        categories[key] = true;
        seriesVina.push(data.vina);
        seriesSantiago.push(data.santiago);
        seriesNoSede.push(data.inPersonNoSede);
        seriesOnline.push(data.online);
        seriesGeneral.push(data.general);
      }
    });
  }
  const tripleColumnChartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'Promedio ensayos',
      align: 'left',
    },
    xAxis: {
      categories: Object.keys(categories),
    },
    tooltip: {
      valueDecimals: 0,
      valueSuffix: '',
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Puntaje promedio',
      },
    },
    series: [
      {
        name: 'Presencial - Viña',
        data: seriesVina,
      },
      {
        name: 'Presencial - Santiago',
        data: seriesSantiago,
      },
      ...(seriesNoSede.some((value) => value > 0) ? [{
        name: 'Presencial sin sede',
        data: seriesNoSede,
      }] : []),
      {
        name: 'Online',
        data: seriesOnline,
      },
      {
        name: 'General',
        data: seriesGeneral,
      },
    ],
  };
  return (
    <Box style={{ width: '33%' }}>
      <HighchartsReact highcharts={Highcharts} options={tripleColumnChartOptions} />
    </Box>
  );
};
